import React from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  children: React.ReactNode;
}

/**
 * body 直下へ描画する。Modal / Drawer / Toast が、祖先の overflow や
 * transform に切り取られないようにするためだけの薄い部品。
 *
 * 描画先を state に持って遅らせない: それをやると最初の commit で中身が
 * 生えず、Modal 側の「開いたら中へフォーカスする」effect が掴む要素を
 * 見失う。SSR はしていないので body は常にある。
 */
export function Portal({ children }: PortalProps) {
  return createPortal(children, document.body);
}
